import "./loading.scss";
import React from "react";

function Loading() {
  return (
    <div className="text-center">
      <span className="loading-spinner-header"></span>
      <span className="loading-spinner-header"></span>
      <span className="loading-spinner-header"></span>
    </div>
  );
}

export default Loading;
